const $qtyBtn = $(".product-form__qty-btn");
if ($qtyBtn.length > 0) {
  $qtyBtn.click(function (event) {
    event.preventDefault();

    const actionType = $(this).data().actionType;

    const $qtyInput = $(".quantity-input");
    let qty = parseInt($qtyInput.val());

    if (actionType == 'minus' && qty > 1) {
      qty -= 1;
    }

    if (actionType == 'plus') {
      qty += 1;
    }

    $qtyInput.val(qty);
  });
}

$('input[type=radio][name=purchase_type]').change(function() {
  $('[data-rc-subscription-content]')[this.value == 'onetime' ? 'addClass' : 'removeClass']('hidden-block');
});